<template>
  <div class="Funds">
    <el-row>
      <el-col :xs="24" :sm="24" :md="16" :lg="16" :xl="16">
        <el-card class="box-card" v-loading="loading">
          <div class="label-md-bold-black">Funds</div>

          <div class="top-margin-20" style="border-bottom: 1px solid #ddd; padding-bottom: 20px">
            <div class="fund-descp top-margin-10">
              <div class="title">Available Cash</div>
              <div class="price">
                {{ funds.available_cash ? funds.available_cash : '00.00' }}
                <i class="el-icon-refresh cursor-pointer" @click="getFundDetailsNetWorkCallBack()"></i>
              </div>
            </div>
          </div>

          <!-- <div class="top-margin-20" style="border-bottom: 1px solid #ddd; padding-bottom: 20px;">
                        <div class="fund-descp">
                            <div class="title">Opening balance</div>
                            <div class="small-price">0.00</div>
                        </div>

                        <div class="fund-descp top-margin-10">
                            <div class="title">Payin</div>
                            <div class="small-price">0.00</div>
                        </div>

                        <div class="fund-descp top-margin-10">
                            <div class="title">Payout</div>
                            <div class="small-price">0.00</div>
                        </div>

                        <div class="fund-descp top-margin-10">
                            <div class="title">Span</div>
                            <div class="small-price">0.00</div>
                        </div>

                        <div class="fund-descp top-margin-10">
                            <div class="title">Delivery Margin</div>
                            <div class="small-price">0.00</div>
                        </div>
                    </div> -->

          <!-- <div class="top-margin-20">
                        <div class="fund-descp">
                            <div class="title">Collateral (Liquid funds)</div>
                            <div class="small-price">{{ funds.collateral_amount ? Number(funds.collateral_amount).toFixed(2) : 'NA' }}</div>
                        </div>

                        <div class="fund-descp top-margin-10">
                            <div class="title">Collateral (Equity)</div>
                            <div class="small-price">0.00</div>
                        </div>

                        <div class="fund-descp top-margin-10">
                            <div class="title">Total collateral</div>
                            <div class="small-price">0.00</div>
                        </div>
                    </div> -->
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { serverAddr } from '../networkConfig';

export default {
  name: 'Funds',

  data() {
    return {
      loading: false,
      funds: {},
    };
  },

  mounted() {
    if (localStorage.getItem('selected_broker')) {
      this.getFundDetailsNetWorkCallBack();
    }
  },

  methods: {
    getFundDetailsNetWorkCallBack() {
      this.loading = true; //displayed loader

      serverAddr
        .post('/trade/v1/fund', {
          broker_id: localStorage.getItem('selected_broker') ? Number(localStorage.getItem('selected_broker')) : '',
        })
        .then((response) => {
          if (response.data.status) {
            this.funds = response.data.data;
          } else {
            this.funds = {};
          }

          this.loading = false; //hide loader
        })
        .catch((error) => {
          console.log(error);
          this.loading = false; //hide loader
          this.funds = {};
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../css/variable.scss';
@import '../css/common.scss';

.Funds {
  .box-card {
    border-radius: 10px;
    box-shadow: none;
  }

  .fund-descp {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .title {
      font-size: 0.9rem;
      color: $label-color;
    }

    .price {
      font-size: 1.3rem;
      font-weight: 600;

      i {
        font-weight: 700;
      }
    }

    .small-price {
      font-size: 1rem;
      font-weight: 500;
    }
  }
}
</style>
